export const Change_Navigate_Index = 'headNavbar/Change_Navigate_Index';
export const Change_Category_Index = 'headNavbar/Change_Category_Index';
export const Change_Category_Show = 'headNavbar/Change_Category_Show';
export const Change_Search_Text = 'headNavbar/Change_Search_Text';
export const Change_Search_Value = 'headNavbar/Change_Search_Value';